import { type ReactNode } from "react"
import classNames from "classnames"

export const Main = ({
  className,
  children,
}: {
  className?: string
  children: ReactNode
}) => <div className={classNames("main", className)}>{children}</div>
